export default "__VITE_ASSET__8f8bb918__"